"use client"

import { Button } from "@/components/ui/button"
import { Grid3x3, List } from "lucide-react"

interface ViewToggleProps {
  viewMode: "grid" | "list"
  onViewChange: (mode: "grid" | "list") => void
  className?: string
}

export function ViewToggle({ viewMode, onViewChange, className = "" }: ViewToggleProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-600 hidden sm:inline">View:</span>
      <div className="flex border border-gray-200 rounded-lg overflow-hidden shadow-xs">
        <Button
          variant={viewMode === "grid" ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewChange("grid")}
          className={`h-11 min-w-11 px-3 rounded-none transition-all duration-200 sm:h-9 sm:min-w-0 ${
            viewMode === "grid"
              ? "bg-green-600 hover:bg-green-700 text-white"
              : "text-gray-600 hover:bg-gray-100"
          }`}
          aria-label="Grid view"
          aria-pressed={viewMode === "grid"}
        >
          <Grid3x3 className="w-4 h-4" />
        </Button>
        <Button
          variant={viewMode === "list" ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewChange("list")}
          className={`h-11 min-w-11 px-3 rounded-none transition-all duration-200 sm:h-9 sm:min-w-0 ${
            viewMode === "list"
              ? "bg-green-600 hover:bg-green-700 text-white"
              : "text-gray-600 hover:bg-gray-100"
          }`}
          aria-label="List view"
          aria-pressed={viewMode === "list"}
        >
          <List className="w-4 h-4" />
        </Button>
      </div>
    </div>
  )
}
